import React from 'react';

const ExpertsInMoneyLogo = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 200 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    data-testid="expertsInMoneyLogo"
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
  >
    <g id="Artboard1" transform="matrix(0.8,0,0,1,0,0)">
      <rect x="0" y="0" width="250" height="50" style={{ fill: 'none' }} />
      <g
        id="Layer_1"
        transform="matrix(0.612455,0,0,0.489964,-6.89839,7.44298)"
      >
        <g transform="matrix(1,0,0,1,0,2.04097)">
          <path
            d="M43.85,56.8L17.57,50.86L43.85,42.72L43.85,56.8Z"
            style={{
              fill: 'rgb(0,176,178)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(1,0,0,1,0,2.04097)">
          <path
            d="M43.85,40.15L15.07,49.07L15.07,35.71L35.01,29.54"
            style={{
              fill: 'rgb(28,20,102)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(1,0,0,1,0,2.04097)">
          <path
            d="M15.06,19.37L43.85,10.44L43.85,24.22L15.06,33.14L15.06,19.37Z"
            style={{
              fill: 'rgb(28,20,102)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(1,0,0,1,0,2.04097)">
          <path
            d="M53.9,18.32L75.48,18.32L75.48,24.78L60.9,24.78L60.9,30.7L74.67,30.7L74.67,37.16L60.9,37.16L60.9,43.62L76.29,43.62L76.29,50.08L53.9,50.08L53.9,18.32Z"
            style={{
              fill: 'rgb(28,20,102)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(1,0,0,1,0,2.04097)">
          <path
            d="M86.91,38.42L79.65,28.28L87.59,28.28L91.44,34.2L95.17,28.28L102.66,28.28L95.57,38.42L103.96,50.08L96.02,50.08L91.27,42.81L86.15,50.08L78.31,50.08L86.91,38.42Z"
            style={{
              fill: 'rgb(28,20,102)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(1,0,0,1,0,2.04097)">
          <path
            d="M112.79,39.18C112.718,40.648 113.229,42.086 114.21,43.18C116.453,45.208 119.907,45.208 122.15,43.18C123.124,42.082 123.63,40.646 123.56,39.18C123.626,37.715 123.12,36.28 122.15,35.18C119.907,33.152 116.453,33.152 114.21,35.18C113.232,36.276 112.722,37.713 112.79,39.18M106.61,28.28L112.79,28.28L112.79,31.15L112.89,31.15C113.177,30.717 113.513,30.318 113.89,29.96C114.353,29.536 114.863,29.167 115.41,28.86C116.017,28.528 116.657,28.26 117.32,28.06C118.033,27.845 118.775,27.737 119.52,27.74C121.024,27.721 122.517,28.003 123.91,28.57C125.191,29.1 126.346,29.894 127.3,30.9C128.256,31.932 128.995,33.146 129.47,34.47C129.994,35.922 130.254,37.456 130.24,39C130.248,40.485 130.011,41.962 129.54,43.37C129.098,44.712 128.421,45.965 127.54,47.07C126.693,48.139 125.63,49.019 124.42,49.65C123.134,50.324 121.701,50.667 120.25,50.65C118.939,50.651 117.638,50.431 116.4,50C115.201,49.576 114.156,48.803 113.4,47.78L113.31,47.78L113.31,60.3L106.59,60.3L106.61,28.28Z"
            style={{
              fill: 'rgb(28,20,102)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(1,0,0,1,0,2.04097)">
          <path
            d="M149.17,36.71C149.215,35.627 148.809,34.573 148.05,33.8C147.265,32.993 146.175,32.553 145.05,32.59C144.366,32.572 143.685,32.694 143.05,32.95C142.512,33.166 142.017,33.477 141.59,33.87C141.193,34.232 140.873,34.671 140.65,35.16C140.421,35.646 140.291,36.173 140.27,36.71L149.17,36.71ZM154.87,46.31C153.788,47.691 152.383,48.787 150.78,49.5C149.176,50.235 147.434,50.616 145.67,50.62C144.058,50.63 142.457,50.356 140.94,49.81C139.513,49.303 138.201,48.518 137.08,47.5C135.98,46.488 135.102,45.258 134.5,43.89C133.247,40.876 133.247,37.484 134.5,34.47C135.104,33.103 135.982,31.874 137.08,30.86C138.201,29.842 139.513,29.057 140.94,28.55C142.457,28.004 144.058,27.73 145.67,27.74C147.124,27.721 148.566,27.996 149.91,28.55C151.146,29.068 152.25,29.858 153.14,30.86C154.037,31.921 154.716,33.147 155.14,34.47C155.629,35.991 155.869,37.582 155.85,39.18L155.85,41.29L140.25,41.29C140.464,42.483 141.082,43.568 142,44.36C142.93,45.133 144.111,45.539 145.32,45.5C146.304,45.533 147.277,45.28 148.12,44.77C148.897,44.26 149.575,43.613 150.12,42.86L154.87,46.31Z"
            style={{
              fill: 'rgb(28,20,102)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(1,0,0,1,0,2.04097)">
          <path
            d="M160,28.28L166.72,28.28L166.72,31.78L166.81,31.78C167.41,30.589 168.288,29.56 169.37,28.78C170.48,28.078 171.778,27.729 173.09,27.78C173.48,27.78 173.87,27.78 174.26,27.83C174.625,27.856 174.986,27.916 175.34,28.01L175.34,34.15C174.875,34.006 174.4,33.892 173.92,33.81C173.437,33.736 172.949,33.7 172.46,33.7C171.416,33.655 170.375,33.839 169.41,34.24C168.706,34.566 168.109,35.087 167.69,35.74C167.266,36.445 167,37.233 166.91,38.05C166.775,39.044 166.711,40.047 166.72,41.05L166.72,50.16L160,50.16L160,28.28Z"
            style={{
              fill: 'rgb(28,20,102)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(1,0,0,1,0,2.04097)">
          <path
            d="M195.2,33.66L189.27,33.66L189.27,40.93C189.27,41.478 189.304,42.026 189.37,42.57C189.413,43.017 189.55,43.449 189.77,43.84C190.005,44.22 190.356,44.514 190.77,44.68C191.321,44.891 191.91,44.99 192.5,44.97C192.972,44.961 193.443,44.921 193.91,44.85C194.395,44.821 194.86,44.643 195.24,44.34L195.24,49.94C194.484,50.211 193.699,50.393 192.9,50.48C192.113,50.571 191.322,50.618 190.53,50.62C189.473,50.629 188.418,50.508 187.39,50.26C186.487,50.047 185.635,49.66 184.88,49.12C184.163,48.6 183.583,47.914 183.19,47.12C182.771,46.177 182.566,45.152 182.59,44.12L182.59,33.66L178.28,33.66L178.28,28.28L182.59,28.28L182.59,21.82L189.31,21.82L189.31,28.28L195.24,28.28L195.2,33.66Z"
            style={{
              fill: 'rgb(28,20,102)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(1,0,0,1,0,2.04097)">
          <path
            d="M210.94,34.69C210.006,33.495 208.556,32.815 207.04,32.86C206.463,32.861 205.894,32.998 205.38,33.26C204.849,33.51 204.526,34.065 204.57,34.65C204.565,35.182 204.899,35.661 205.4,35.84C206.079,36.134 206.786,36.358 207.51,36.51L210.25,37.14C211.202,37.343 212.121,37.68 212.98,38.14C213.832,38.629 214.556,39.315 215.09,40.14C215.687,41.13 215.976,42.275 215.92,43.43C215.968,44.656 215.648,45.868 215,46.91C214.394,47.812 213.59,48.564 212.65,49.11C211.647,49.677 210.555,50.069 209.42,50.27C208.25,50.496 207.061,50.609 205.87,50.61C204.311,50.603 202.76,50.384 201.26,49.96C199.745,49.561 198.363,48.763 197.26,47.65L201.35,43.12C201.915,43.846 202.623,44.448 203.43,44.89C204.257,45.306 205.174,45.512 206.1,45.49C206.817,45.5 207.53,45.388 208.21,45.16C208.772,45.016 209.163,44.5 209.15,43.92C209.158,43.366 208.83,42.858 208.32,42.64C207.648,42.318 206.94,42.079 206.21,41.93L203.48,41.3C202.527,41.089 201.605,40.753 200.74,40.3C199.889,39.853 199.163,39.2 198.63,38.4C198.035,37.406 197.746,36.258 197.8,35.1C197.771,33.944 198.044,32.8 198.59,31.78C199.094,30.871 199.799,30.088 200.65,29.49C201.54,28.872 202.537,28.424 203.59,28.17C204.691,27.887 205.823,27.743 206.96,27.74C208.429,27.745 209.89,27.957 211.3,28.37C212.723,28.765 214.013,29.539 215.03,30.61L210.94,34.69Z"
            style={{
              fill: 'rgb(28,20,102)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(1,0,0,1,0,2.04097)">
          <path
            d="M227.53,23.27C227.535,21.133 229.293,19.375 231.43,19.37C233.56,19.384 235.305,21.14 235.305,23.27C235.305,24.29 234.904,25.271 234.19,26C233.466,26.742 232.467,27.155 231.43,27.14C229.293,27.135 227.535,25.377 227.53,23.24"
            style={{
              fill: 'rgb(28,20,102)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(1,0,0,1,0,2.04097)">
          <rect
            x="228.06"
            y="28.74"
            width="6.73"
            height="21.8"
            style={{ fill: 'rgb(28,20,102)' }}
          />
        </g>
        <g transform="matrix(1,0,0,1,0,2.04097)">
          <path
            d="M239.64,28.74L246.1,28.74L246.1,31.74L246.19,31.74C246.425,31.28 246.725,30.855 247.08,30.48C247.493,30.044 247.964,29.668 248.48,29.36C249.056,29.011 249.674,28.739 250.32,28.55C251.044,28.336 251.795,28.231 252.55,28.24C253.968,28.181 255.381,28.448 256.68,29.02C257.683,29.505 258.532,30.26 259.13,31.2C259.739,32.2 260.14,33.312 260.31,34.47C260.529,35.819 260.636,37.184 260.63,38.55L260.63,50.55L253.9,50.55L253.9,39.86C253.9,39.227 253.88,38.56 253.84,37.86C253.801,37.222 253.662,36.595 253.43,36C253.232,35.453 252.886,34.972 252.43,34.61C251.841,34.215 251.138,34.025 250.43,34.07C249.697,34.035 248.969,34.197 248.32,34.54C247.802,34.838 247.376,35.275 247.09,35.8C246.798,36.351 246.609,36.951 246.53,37.57C246.44,38.253 246.397,38.941 246.4,39.63L246.4,50.53L239.67,50.53L239.64,28.74Z"
            style={{
              fill: 'rgb(28,20,102)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(1,0,0,1,0,2.04097)">
          <path
            d="M272.88,18.72L283.46,18.72L290.77,39.44L290.86,39.44L298.22,18.72L308.76,18.72L308.76,50.48L301.76,50.48L301.76,26.12L301.67,26.12L293.33,50.48L287.99,50.48L279.97,26.12L279.87,26.12L279.87,50.48L272.88,50.48L272.88,18.72Z"
            style={{
              fill: 'rgb(0,176,178)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(1,0,0,1,0,2.04097)">
          <path
            d="M320.28,39.58C320.214,41.047 320.724,42.483 321.7,43.58C323.943,45.597 327.387,45.597 329.63,43.58C330.61,42.485 331.12,41.047 331.05,39.58C331.12,38.113 330.61,36.675 329.63,35.58C327.392,33.549 323.938,33.549 321.7,35.58C320.724,36.677 320.214,38.113 320.28,39.58M313.55,39.58C313.528,37.96 313.852,36.355 314.5,34.87C315.102,33.502 315.98,32.272 317.08,31.26C318.202,30.26 319.51,29.492 320.93,29C323.994,27.92 327.336,27.92 330.4,29C331.826,29.509 333.137,30.294 334.26,31.31C335.36,32.32 336.236,33.55 336.83,34.92C338.083,37.934 338.083,41.326 336.83,44.34C336.236,45.71 335.36,46.94 334.26,47.95C333.137,48.966 331.826,49.751 330.4,50.26C327.336,51.34 323.994,51.34 320.93,50.26C319.506,49.753 318.197,48.968 317.08,47.95C315.98,46.938 315.102,45.708 314.5,44.34C313.853,42.855 313.529,41.25 313.55,39.63"
            style={{
              fill: 'rgb(0,176,178)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(1,0,0,1,0,2.04097)">
          <path
            d="M341.72,28.68L348.18,28.68L348.18,31.68L348.27,31.68C348.509,31.219 348.812,30.795 349.17,30.42C349.582,29.987 350.05,29.611 350.56,29.3C351.134,28.951 351.753,28.681 352.4,28.5C353.127,28.283 353.882,28.175 354.64,28.18C356.059,28.121 357.473,28.392 358.77,28.97C359.768,29.454 360.613,30.205 361.21,31.14C361.819,32.144 362.224,33.259 362.4,34.42C362.616,35.769 362.72,37.134 362.71,38.5L362.71,50.5L356,50.5L356,39.8C356,39.18 356,38.52 355.93,37.85C355.891,37.212 355.752,36.585 355.52,35.99C355.323,35.443 354.976,34.961 354.52,34.6C353.933,34.201 353.228,34.011 352.52,34.06C351.788,34.03 351.06,34.192 350.41,34.53C349.891,34.831 349.462,35.266 349.17,35.79C348.878,36.341 348.689,36.941 348.61,37.56C348.525,38.243 348.482,38.931 348.48,39.62L348.48,50.48L341.75,50.48L341.72,28.68Z"
            style={{
              fill: 'rgb(0,176,178)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(1,0,0,1,0,2.04097)">
          <path
            d="M382.4,37.11C382.451,36.026 382.045,34.97 381.28,34.2C380.497,33.389 379.407,32.946 378.28,32.98C377.595,32.967 376.915,33.093 376.28,33.35C375.747,33.566 375.256,33.874 374.83,34.26C374.432,34.625 374.112,35.068 373.89,35.56C373.662,36.047 373.53,36.573 373.5,37.11L382.4,37.11ZM388.1,46.71C387.016,48.091 385.608,49.184 384,49.89C382.4,50.623 380.66,51.001 378.9,51C377.291,51.011 375.693,50.737 374.18,50.19C372.753,49.683 371.441,48.898 370.32,47.88C369.214,46.873 368.334,45.643 367.74,44.27C366.487,41.256 366.487,37.864 367.74,34.85C368.334,33.477 369.214,32.247 370.32,31.24C371.447,30.247 372.759,29.486 374.18,29C375.693,28.453 377.291,28.179 378.9,28.19C380.354,28.17 381.796,28.445 383.14,29C384.378,29.516 385.482,30.306 386.37,31.31C387.268,32.369 387.948,33.596 388.37,34.92C388.868,36.44 389.111,38.031 389.09,39.63L389.09,41.74L373.52,41.74C373.736,42.933 374.354,44.016 375.27,44.81C376.202,45.579 377.382,45.984 378.59,45.95C379.579,45.984 380.556,45.727 381.4,45.21C382.177,44.704 382.854,44.06 383.4,43.31L388.1,46.71Z"
            style={{
              fill: 'rgb(0,176,178)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(1,0,0,1,0,2.04097)">
          <path
            d="M405.77,54C405.32,55.17 404.89,56.2 404.47,57.09C404.087,57.939 403.547,58.709 402.88,59.36C402.181,60.006 401.343,60.482 400.43,60.75C399.161,61.103 397.846,61.262 396.53,61.22C394.831,61.222 393.142,60.949 391.53,60.41L392.42,54.9C393.411,55.342 394.485,55.571 395.57,55.57C396.19,55.589 396.808,55.505 397.4,55.32C397.847,55.179 398.254,54.936 398.59,54.61C398.919,54.276 399.186,53.887 399.38,53.46C399.59,53.01 399.81,52.46 400.05,51.89L400.55,50.64L390.99,28.64L398.26,28.64L403.86,43.04L403.95,43.04L408.75,28.64L415.66,28.64L405.77,54Z"
            style={{
              fill: 'rgb(0,176,178)',
              fillRule: 'nonzero',
            }}
          />
        </g>
      </g>
    </g>
  </svg>
);

export default ExpertsInMoneyLogo;
